import { SelfDescribingJson } from '@snowplow/tracker-core';

import { WorkspaceContext } from '../contexts/WorkspaceContext';

export const mapWorkspaceContext = (
  workspace: WorkspaceContext,
): SelfDescribingJson<Record<string, unknown>> => {
  return {
    schema: 'iglu:com.genially/workspace/jsonschema/1-1-0',
    data: {
      workspace_id: workspace.id,
      plan_type: workspace.planType,
      name: workspace.name,
      n_seats: workspace.totalSeatsNumber,
      n_general_seats: workspace.generalSeatsNumber,
      n_student_seats: workspace.studentSeatsNumber,
      n_members: workspace.totalMembersNumber,
      n_general_members: workspace.generalMembersNumber,
      n_student_members: workspace.studentMembersNumber,
      n_guests: workspace.numberOfGuests,
    },
  };
};
